import { FeedbackOriginPhraseRecord } from "@productlane/lib/src/feedback-origin"

import { slackDomain } from "@/screens/settings/integrations/slack-channel-list"

/** The top bar tooltip's first line, naming the workspace when several are connected. */
export function slackOriginPhrase(origin: { name: string } | null): string {
	const phrase = FeedbackOriginPhraseRecord.SLACK_CONNECT
	return origin ? `${phrase} · ${origin.name}` : phrase
}

/** The Slack workspace a thread came from, or null when one workspace is connected or the channel is unknown. */
export function resolveSlackOrigin({
	connections,
	channel,
	teams,
}: {
	connections: readonly { id: string; teamUrl: string }[]
	channel: { slackConnectSettingsId: string } | null | undefined
	teams:
		| readonly { id: string; name: string | null; iconUrl: string | null }[]
		| undefined
}): { name: string; iconUrl: string | null } | null {
	if (connections.length < 2 || !channel) return null
	const connection = connections.find(
		(row) => row.id === channel.slackConnectSettingsId,
	)
	if (!connection) return null
	const team = teams?.find((row) => row.id === connection.id)
	// Until Slack answers, the domain names the workspace.
	return {
		name: team?.name ?? slackDomain(connection.teamUrl),
		iconUrl: team?.iconUrl ?? null,
	}
}
